const cardHighlight = (post) => {
  return `
<div class="card">
  <span class="gradient"></span>
  <a href="/blog/${post.slug}">
    <img
      alt="${post.title}"
      src="${post.image}"
      class="image"
    />
  </a>
  <div class="content">
    <div class="time-container">
      <time datetime="${post.updatedAt.split("T")[0]}" class="date">
        ${post.updatedAt.split("T")[0]}
      </time>
      <span class="minutes">${post.minutes} min.</span>
    </div>
    <a href="/blog/${post.slug}" class="title">${post.title}</a>
    <p class="description">${post.shortDescription}</p>


    <div class="user-info">
      <div class="avatar">
        <img
          src="${post.author.image}"
          alt="${post.author.name}"
        />
      </div>
      <div class="details">
        <p>${post.author.name}</p>
      </div>
    </div>
  </div>
</div>`;
};

const cardPost = (post) => {
  return `
  <article>
    <a href="/blog/${post.slug}">
    <img src="${post.image}" alt="${post.title}" />
    </a>
    <div class="meta">
      <time dateTime="${post.updatedAt.split("T")[0]}">
        ${post.updatedAt.split("T")[0]}
      </time>
      <div class="info">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-book-open-text"><path d="M12 7v14"/><path d="M16 12h2"/><path d="M16 8h2"/><path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"/><path d="M6 12h2"/><path d="M6 8h2"/></svg>
        <span>${post.minutes} min.</span>
      </div>
    </div>
    <div class="content">
      <a href="/blog/${post.slug}">
      ${post.title}
      </a>
      <p>
        ${post.shortDescription}
      </p>

      <div class="user-info">
        <div class="avatar">
          <img
            src="${post.author.image}"
            alt="${post.author.name}"
          />
        </div>
        <div class="details">
          <p>${post.author.name}</p>
        </div>
    </div>

    </div>
  </article>
`;
};

function generateBreadcrumb() {
  const breadcrumbsContainer = document.getElementById("breadcrumbs");

  // Obtener el pathname y dividirlo en segmentos
  const pathname = window.location.pathname;
  const segments = pathname.split("/").filter((segment) => segment !== "");

  // Definir un diccionario de traducciones si lo necesitas
  const translations = {
    blog: "Blog",
    categoria: "Categoría",
    "la-interseccion-de-tecnologias-procesos-empresariales-y-software-a-medida":
      "La Intersección de Tecnologías, Procesos Empresariales y Software a Medida",
  };

  // Construir las migas de pan dinámicamente
  const crumbs = segments.map((segment, index) => {
    // Traducción o manejo de segmentos
    const translatedSegment = translations[segment] || segment;
    const decodedString = decodeURIComponent(
      translatedSegment.replace(/_/g, " ")
    );

    // Corregir signos de interrogación
    const correctedString = decodedString.startsWith("¿")
      ? decodedString + "?"
      : decodedString;

    // Construir la URL para cada miga de pan
    const url = `/${segments.slice(0, index + 1).join("/")}`;

    return { title: correctedString, url };
  });

  // Agregar la miga de 'Home' al inicio manualmente
  crumbs.unshift({ title: "Home", url: "/" });

  // Limpiar el contenido previo
  breadcrumbsContainer.innerHTML = "";

  // Crear la lista ordenada <ol>
  const ol = document.createElement("ol");

  crumbs.forEach((crumb, index) => {
    const li = document.createElement("li");
    li.className = "breadcrumb-detail-item";

    if (index === 0) {
      const link = document.createElement("a");
      link.href = crumb.url;
      link.className = "link home gray";
      link.textContent = crumb.title;

      // Crear el elemento SVG
      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttribute("width", "24");
      svg.setAttribute("height", "24");
      svg.setAttribute("viewBox", "0 0 24 24");
      svg.setAttribute("fill", "none");
      svg.setAttribute("stroke", "currentColor");
      svg.setAttribute("stroke-width", "2");
      svg.setAttribute("stroke-linecap", "round");
      svg.setAttribute("stroke-linejoin", "round");
      svg.classList.add("lucide", "lucide-house");

      // Crear el path del SVG
      const path1 = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "path"
      );
      path1.setAttribute("d", "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8");

      const path2 = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "path"
      );
      path2.setAttribute(
        "d",
        "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
      );
      svg.style.marginRight = "5px";

      // Añadir los paths al SVG
      svg.appendChild(path1);
      svg.appendChild(path2);

      // Añadir el SVG al enlace
      link.prepend(svg); // Prepend añade el SVG al inicio del enlace
      li.appendChild(link);
    } else {
      const arrow = document.createElement("span");
      arrow.className = "arrow";
      arrow.classList.add(index === crumbs.length - 1 ? "gray" : "white");
      li.appendChild(arrow);

      const link = document.createElement("a");
      link.href = crumb.url;
      link.className = "link";
      link.textContent = crumb.title;

      link.classList.add(index === crumbs.length - 1 ? "white" : "gray");
      li.appendChild(link);
    }

    ol.appendChild(li);
  });

  // Agregar la lista ordenada al contenedor de migas de pan
  breadcrumbsContainer.appendChild(ol);
}

const loadHome = async () => {
  try {
    const response = await fetch(
      "https://zealous-stone-02a374310.5.azurestaticapps.net/api/posts?blog=true"
    );
    const data = await response.json();
    const cardContainer = document.getElementById("card-container");
    cardContainer.innerHTML = "";
    const cardsContainer = document.getElementById("containerCards-card");
    data.highlights.forEach((post) => {
      const cardHTML = cardHighlight(post);
      cardContainer.innerHTML += cardHTML;
    });
    data.posts.forEach((post) => {
      const cardHTML = cardPost(post);
      cardsContainer.innerHTML += cardHTML;
    });
    renderPosts(data.newPosts);
  } catch (error) {
    console.error("Error fetching posts:", error);
  }
};

const renderPosts = (posts) => {
  const postLarge = document.querySelector(".post-large");
  const postsSmall = document.querySelector(".posts-small");

  // Limpiar el contenido previo
  postLarge.innerHTML = "";
  postsSmall.innerHTML = "";

  // Iterar sobre los posts y añadirlos al contenedor adecuado
  posts.forEach((post, index) => {
    const postHTML = `
      <a class="content" href="/blog/${post.slug}">
        <div class="meta-info">
          <time datetime="${post.updatedAt.split("T")[0]}">${
      post.updatedAt.split("T")[0]
    }</time>
          <span class="reading-time"> | <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-book-open-text"><path d="M12 7v14"/><path d="M16 12h2"/><path d="M16 8h2"/><path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"/><path d="M6 12h2"/><path d="M6 8h2"/></svg> ${
            post.minutes
          } min.</span>
        </div>
        <h3>${post.title}</h3>
        <div class="description-container">
          <p class="description">${post.shortDescription}</p>
        </div>
      </a>
    `;

    // Condicional para asignar el post grande o los posts pequeños
    if (index === 0) {
      // Primer post (grande)
      postLarge.innerHTML = `
        <img src="${post.image}" alt="${post.title}">
        ${postHTML}
      `;
    } else {
      // Posts pequeños
      const smallPostHTML = `
        <div class="left-section">
          <a href="/blog/${post.slug}" class="image-link">
            <img src="${post.image}" alt="${post.title}">
          </a>
        </div>
        <div class="right-section">
          <div class="meta-info">
            <time datetime="${post.updatedAt.split("T")[0]}">${
        post.updatedAt.split("T")[0]
      }</time>
            <span class="reading-time"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-book-open-text"><path d="M12 7v14"/><path d="M16 12h2"/><path d="M16 8h2"/><path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"/><path d="M6 12h2"/><path d="M6 8h2"/></svg> ${
              post.minutes
            } min.</span>
          </div>
          <a href="/blog/${post.slug}" class="title">${post.title}</a>
          <p class="description">${post.shortDescription}</p>
        </div>
      `;

      // Añadir el contenido del post pequeño
      const smallPostContainer = document.createElement("div");
      smallPostContainer.classList.add("post-small");
      smallPostContainer.innerHTML = smallPostHTML;
      postsSmall.appendChild(smallPostContainer);
    }
  });
};

const setMetaTag = (property, content) => {
  let meta = document.querySelector(`meta[property='${property}']`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("property", property);
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", content);
};

// Cargar Detalle del Post
const loadDetail = async (blogId, callback) => {
  try {
    const response = await fetch(
      "https://zealous-stone-02a374310.5.azurestaticapps.net/api/posts/" +
        blogId
    );
    const responsePosts = await fetch(
      "https://zealous-stone-02a374310.5.azurestaticapps.net/api/posts?idPost=" +
        blogId
    );
    const data = await response.json();
    const posts = await responsePosts.json();
    const container = document.getElementById("containerPost");
    const detailContainer = document.getElementById("detailContainer");
    const cardsContainer = document.getElementById(
      "containerCards-card-detail"
    );
    setMetaTag("og:title", data.title);
    setMetaTag("og:description", data.shortDescription);
    setMetaTag("og:image", data.image);
    setMetaTag("og:url", `https://valtecconsultores.com.pe/blog/${data.slug}`);
    document.querySelector(".containerSubTitle .subtitle").textContent =
      data.title;
    document.querySelector(".containerSubTitle .description").textContent =
      data.shortDescription;

    createSocialShare("Compartir", data, container);

    const img = document.createElement("img");
    img.src = data.image;
    img.alt = data.title;
    img.className = "image";
    container.appendChild(img);

    // Lexical Facebook
    const lexicalState = JSON.parse(data.description);
    detailContainer.appendChild(renderLexicalState(lexicalState));

    createSocialShare("Comparte este artículo", data, detailContainer);

    const Author = `
    <div class="autor-flex-container">
      <div class="autor-image-container">
        <img src="${data.author.image}" alt="${data.author.name}" />
      </div>
      <div class="autor-text-container">
        <h3>${data.author.name}</h3>
        <p>${data.author.description}</p>
      </div>
    </div>
    `;

    detailContainer.innerHTML += Author;

    posts.forEach((post) => {
      const cardHTML = cardPost(post);
      cardsContainer.innerHTML += cardHTML;
    });
    document.title = "Blog - Valtec | " + data.title;
    generateBreadcrumb();
  } catch (error) {
    console.error("Error fetching posts:", error);
  }
  callback();
};

function createSocialShare(text, post, container) {
  const socialShareDiv = document.createElement("div");
  socialShareDiv.className = "social-share";

  const label = document.createElement("label");
  label.innerText = text;

  const links = [
    {
      href: `https://www.linkedin.com/shareArticle?mini=true&url=https://valtecconsultores.com.pe/blog/${post.slug}&title=${post.title}&summary=${post.shortDescription}&source=valtecconsultores.com.pe`,
      iconClass: "bx bxl-linkedin", // Clases para LinkedIn
    },
    {
      href: `https://www.facebook.com/sharer/sharer.php?u=https://valtecconsultores.com.pe/blog/${post.slug}`,
      iconClass: "bx bxl-facebook", // Clases para Facebook
    },
    {
      href: `https://wa.me/?text=https://valtecconsultores.com.pe/blog/${post.slug}`,
      iconClass: "bx bxl-whatsapp", // Clases para WhatsApp
    },
    {
      href: "https://www.instagram.com/valtec_consultores/",
      iconClass: "bx bxl-instagram", // Clases para Instagram
    },
  ];

  // Crear enlaces
  links.forEach((link) => {
    const anchor = document.createElement("a");
    anchor.href = link.href;
    anchor.className = "link";
    anchor.target = "_blank";
    // Crear el icono
    const icon = document.createElement("i");
    icon.className = link.iconClass + " icon"; // Añadir las clases del icono

    anchor.appendChild(icon);
    socialShareDiv.appendChild(anchor);
  });

  socialShareDiv.prepend(label);
  container.appendChild(socialShareDiv);
}

// Lexical ya que no hay CDN
function renderLexicalState(state) {
  const root = document.createElement("div"); // Crear un contenedor
  root.className = "lexical";
  state.root.children.forEach((child) => {
    if (child.type === "paragraph") {
      let hasContent = false;
      const paragraph = document.createElement("p");

      child.children.forEach((textNode) => {
        if (textNode.type === "text" && textNode.text.trim() !== "") {
          hasContent = true;
          const span = document.createElement("span");
          span.textContent = textNode.text;

          // Formato de texto en negrita
          if (textNode.format === 1) {
            const strong = document.createElement("strong");
            strong.textContent = textNode.text;
            paragraph.appendChild(strong);
          } else {
            paragraph.appendChild(span);
          }
        } else if (textNode.type === "autolink") {
          console.log(textNode);

          hasContent = true;
          const anchor = document.createElement("a");
          const cleanedURL =
            "https://" + textNode.url.replace(/https:\/\//g, "");
          anchor.href = cleanedURL;
          anchor.textContent = cleanedURL;
          anchor.style.color = "blue"; // Estilo de enlace
          anchor.style.textDecoration = "underline";
          anchor.target = "_blank";
          paragraph.appendChild(anchor);
        } else if (textNode.type === "link") {
          console.log(textNode);

          hasContent = true;
          const anchor = document.createElement("a");
          const cleanedURL = textNode.url;

          anchor.href = cleanedURL;
          anchor.style.color = "blue"; // Estilo de enlace
          anchor.style.textDecoration = "underline";
          anchor.target = textNode.target || "_blank"; // Establecer target si existe
          anchor.rel = textNode.rel || "noopener noreferrer"; // Buena práctica de seguridad
          anchor.title = textNode.title || ""; // Título si existe

          // Manejar hijos del enlace (children)
          if (textNode.children && Array.isArray(textNode.children)) {
            textNode.children.forEach((childNode) => {
              if (childNode.type === "text" && childNode.text) {
                anchor.textContent = childNode.text; // Agregar el texto del enlace
                console.log(childNode.text);

                if (childNode.text.trim() === "Solicita Asesoría Gratis Hoy") {
                  anchor.title =
                    "Conoce más de Copilot y Agenda una Asesoría Gratis";
                }
              }
              if (childNode.style) {
                anchor.setAttribute("style", childNode.style);
                paragraph.style.textAlign = "center"; // Alinear al centro
              }
            });
          } else {
            anchor.textContent = textNode.text || cleanedURL; // Fallback
          }

          paragraph.appendChild(anchor); // Agregar enlace al párrafo
        } else if (textNode.type === "image") {
          hasContent = true;
          const imgContainer = document.createElement("div"); // Contenedor para la imagen
          const img = document.createElement("img"); // Crear un elemento <img>
          img.src = textNode.src; // Asignar la fuente de la imagen
          img.alt = textNode.alt || ""; // Asignar texto alternativo si está disponible
          img.style.display = "block"; // Mostrar la imagen como bloque
          img.style.margin = "10px auto"; // Centramos la imagen
          img.style.maxWidth = "100%"; // Centramos la imagen
          imgContainer.style.textAlign = "center"; // Alinear al centro
          imgContainer.appendChild(img); // Agregar la imagen al contenedor de imagen
          paragraph.appendChild(imgContainer); // Agregar el contenedor de imagen al párrafo
        }
      });

      if (hasContent) {
        root.appendChild(paragraph);
      } else {
        root.appendChild(document.createElement("br"));
      }
    } else if (child.type === "list") {
      const list = child.ordered
        ? document.createElement("ol")
        : document.createElement("ul");
      child.children.forEach((listItem) => {
        const listElement = document.createElement("li");
        listElement.style.listStyle =
          child.listType === "bullet" ? "disc" : "decimal";
        listItem.children.forEach((itemNode) => {
          if (itemNode.type === "text") {
            const span = document.createElement("span");
            span.textContent = itemNode.text;

            if (itemNode.format === 1) {
              const strong = document.createElement("strong");
              strong.textContent = itemNode.text;
              listElement.appendChild(strong);
            } else {
              listElement.appendChild(span);
            }
          } else if (itemNode.type === "autolink") {
            const anchor = document.createElement("a");
            const cleanedURL =
              "https://" + textNode.url.replace(/https:\/\//g, "");
            anchor.href = cleanedURL;
            anchor.textContent = cleanedURL;
            anchor.target = "_blank";
            listElement.appendChild(anchor);
          } else if (itemNode.type === "image") {
            const img = document.createElement("img");
            img.src = itemNode.src;
            img.alt = itemNode.alt || "";
            img.style.maxWidth = "100%";
            img.style.height = "auto";
            listElement.appendChild(img);
          }
        });

        list.appendChild(listElement);
      });

      root.appendChild(list);
    } else if (child.type === "quote") {
      const blockquote = document.createElement("blockquote");
      blockquote.style.borderLeft = "4px solid #ccc";
      blockquote.style.paddingLeft = "10px";
      blockquote.style.margin = "10px 0";

      child.children.forEach((quoteNode) => {
        if (quoteNode.type === "text") {
          const span = document.createElement("span");
          span.textContent = quoteNode.text;
          blockquote.appendChild(span);
        }
      });

      root.appendChild(blockquote);
    }
  });

  return root;
}
